export const FETCH_PROFILE_REQUESTED = '@@Main/fetchProfile@Requested'
export const FETCH_PROFILE_SUCCESS = '@@Main/fetchProfile@Success'
export const FETCH_PROFILE_FAILURE = '@@Main/fetchProfile@Failure'

export const FETCH_EVENTS_REQUESTED = '@@Main/fetchEvents@Requested'
export const FETCH_EVENTS_SUCCESS = '@@Main/fetchEvents@Success'
export const FETCH_EVENTS_FAILURE = '@@Main/fetchEvents@Failure'

export const FETCH_MORE_EVENTS_REQUESTED = '@@Main/fetchMoreEvents@Requested'
export const FETCH_MORE_EVENTS_SUCCESS = '@@Main/fetchMoreEvents@Success'
export const FETCH_MORE_EVENTS_FAILURE = '@@Main/fetchMoreEvents@Failure'

export const CHANGE_NAME = '@@Main/changeName'
export const CHANGE_EVENT_TYPE = '@@Main/changeEventType'
